import controller from './facture-x-error-report-modal.controller';
import template from './facture-x-error-report-modal.tpl.html';

export default {
	bindings: {
		modalInstance: '=',
		resolve: '='
	},
	template,
	controller
};
